<template>
  <div class="top">
    <div class="mShow">
      <a-icon class="left" type="menu" @click="showDrawer"/>
      <div>
        <a-drawer
          :placement="placement"
          :closable="true"
          :mask="false"
          :visible="visible"
          @close="onClose"
        >
          <div class="tab">
            <div class="tab-title" @click="toProd">RECOMMENDATION<a-icon type="right" /></div>
            <div class="tab-title" @click="toDietary">DIETARY SUGGESTION<a-icon type="right" /></div>
            <div class="tab-title" @click="toSpecial">SPECIAL REMINDER<a-icon type="right" /></div>
          </div>
        </a-drawer>
      </div>
    </div>
    <div class="pcShow">
      <a-dropdown>
        <a class="ant-dropdown-link" @click="e => e.preventDefault()">
          RESULT LIST
        </a>
        <a-menu class="drop-down" slot="overlay">
          <a-menu-item>
            <a class="text" href="javascript:;" @click="toProd">RECOMMENDATION</a>
          </a-menu-item>
          <a-menu-item>
            <a class="text" href="javascript:;" @click="toDietary">DIETARY SUGGESTION</a>
          </a-menu-item>
          <a-menu-item>
            <a class="text" href="javascript:;" @click="toSpecial">SPECIAL REMINDER</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <div class="center">
      <a href="https://life.femometer.com">
        <img class="mainLogo" src="@/assets/logo.png" alt="">
      </a>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      visible: false,
      placement: 'left',
    };
  },
  methods: {
    toSpecial () {
      this.$router.push('special')
      this.visible = false
    },
    toDietary () {
      this.$router.push('dietary')
      this.visible = false
    },
    toProd () {
      this.$router.push('product')
      this.visible = false
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    onChange(e) {
      this.placement = e.target.value;
    },
  },
}
</script>

<style scoped lang="less">
.drop-down {
  z-index: 1;
  width: 227px;
  padding: 41px 0px 30px 36px;
  position: absolute;
  left: -30px;
  flex-direction: column;
  display: flex;
  // align-items: center;
  justify-content: space-between;
  height: 150px;
  background: #FBF3EE;
  box-shadow: 0px 2px 4px 0px rgba(223, 214, 214, 0.5);
  .text {
    // width: 139px;
    height: 13px;
    font-size: 12px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #000000;
    line-height: 14px;
    letter-spacing: 1px;
    &:hover {
      background-color: #FBF3EE;
    }
  }
}
.ant-dropdown-link {
  position: absolute;
  left: 68px;
  top: 33px;
  width: 88px;
  height: 13px;
  font-size: 12px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #000000;
  line-height: 14px;
  letter-spacing: 1px;
}
/deep/ .ant-drawer-content-wrapper {
  // width: 229.5px !important;
  .ant-drawer-content {
    background: #E26CA5;
  }
  .anticon svg {
    color: #FBF3EE;
  }
  .ant-drawer-body {
    padding: 0;
  }
}
.tab {
  padding-top: 93px;
  height: 452px;
  .tab-title {
    font-size: 12.5px;
    padding: 0 18.5px;
    border-bottom: 1px solid #FBF3EE;
    // width: 229.5px;
    justify-content: space-between;
    font-family: Helvetica;
    color: #FFFFFF;
    line-height: 15px;
    height: 52px;
    display: flex;
    align-items: center;
  }
}
.top {
  width: 100%;
  z-index: 10;
  position: absolute;
  height: 72.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.5px solid #DCDCDC;
  .left {
    position: absolute;
    left: 22.5px;
    top: 23.5px;
    font-size: 20px;
  }
  .mainLogo{
    width: 170px;
  }
}
@media only screen and (max-width: 767px) {
  .mainLogo{
    width: 100px!important;
  }
  .top {
    position: absolute;
    top: 0;
  }
}
@media only screen and (min-width: 767px) {
  .top {
    // position: absolute;
  }
}
</style>